<template>
  <div class="w-full min-w-0">
    <div
      class="flex w-full min-w-0 overflow-x-auto gap-7 tabs-container"
    >
      <div
        v-for="option in options"
        :key="option.value"
        :class="[
          'flex justify-center items-center p-3 gap-2',
          (option.disabled) ? 'cursor-not-allowed' : 'cursor-pointer',
          selectedOption === option.value
            ? 'selected-tab'
            : 'text-black dark:text-white'
        ]"
        @click="!option.disabled && onSelect(option)"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabsComponent',
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedOption: {
      type: String,
      required: true,
    },
  },
  methods: {
    onSelect (option) {
      if (!this.disabled && !option.disabled) {
        this.$emit('update:selectedOption', option?.value);
      }
    },
  },
};
</script>

<style scoped>
  .tabs-container {
    border-bottom: 1px solid #EEE;
  }
  .selected-tab {
    border-bottom: 1px solid #3b82f680;
    color: #3b82f6;
  }
</style>
